module.exports = __webpack_public_path__ + "static/media/bot.cfb77e67.svg";